module.exports = __webpack_public_path__ + "static/img/14000131.fbde179e.png";